import { Dispatch } from '@reduxjs/toolkit';
import { IStore, MARKET_DATA_STORE_NAME } from './store';
import { ExchangeId, marketDataWsActions, Symbol } from '@cmctechnology/webinvest-api-client-market-data-ws';

export const mapFxRateToSymbol: Record<string, string> = {
  ['HKD/SGD']: 'SGD/HKD',
  ['USD/SGD']: 'SGD/USD',
  ['NZD/SGD']: 'SGD/NZD',
  ['EUR/SGD']: 'SGD/EUR',
  ['CAD/SGD']: 'SGD/CAD',
  ['DKK/SGD']: 'SGD/DKK',
  ['GBP/SGD']: 'SGD/GBP',
  ['CHF/SGD']: 'SGD/CHF',
  ['JPY/SGD']: 'SGD/JPY',

  ['HKD/AUD']: 'AUD/HKD',
  ['USD/AUD']: 'AUD/USD',
  ['NZD/AUD']: 'AUD/NZD',
  ['CAD/AUD']: 'AUD/CAD',
  ['DKK/AUD']: 'AUD/DKK',
  ['JPY/AUD']: 'AUD/JPY',
  ['SGD/AUD']: 'AUD/SGD',
  ['CHF/AUD']: 'AUD/CHF'
};

const getFxRateInstrument = (fromCurrencyCode: string, toCurrencyCode: string) => {
  const symbol = `${fromCurrencyCode}/${toCurrencyCode}`;
  return mapFxRateToSymbol[symbol] ?? symbol;
};

let quotesUseWs = false;
export const setQuotesUseWs = (value: boolean) => (quotesUseWs = value);
export const getQuotesUseWs = () => quotesUseWs;

export const subscribeWsQuotes = () => {
  return (dispatch: Dispatch<any>, getState: () => IStore) => {
    const fxRates = getState()[MARKET_DATA_STORE_NAME].fxRateSubscriptions;
    const accounts = [...new Set(fxRates.map((fxRate) => fxRate.accountNo))];
    const fxRateSubs = fxRates.map(
      (fxRate) => ({ exchangeId: ExchangeId.Forex, stockCode: getFxRateInstrument(fxRate.fromCurrencyCode, fxRate.toCurrencyCode) }) as Symbol
    );

    const quoteSubs = getState()[MARKET_DATA_STORE_NAME].quoteSubscriptions.map((quoteSub) => ({
      exchangeId: quoteSub.exchangeId,
      stockCode: quoteSub.instrumentCode
    }));

    dispatch(
      marketDataWsActions.send({
        subscribeQuoteV1: {
          accounts,
          action: `subscribe`,
          interval: `1s`,
          symbols: [...fxRateSubs, ...quoteSubs]
        }
      })
    );
  };
};
